import {initialForm} from "./helpers"
import recapthaMixin from "@/components/features/Recaptha/recaptchaMixin"

export default {
    mixins: [
        recapthaMixin,
    ],
    data() {
        return {
            ecpLoginModal: false,
            form: Object.assign({}, initialForm),
            authLoading: false,
            tokenLoading: false,
            ecpLoginLoading: false,
            loginHash: null,
            user_id: null,
            usersList: [],
            blocked: false
        };
    },
    computed: {
        showCaptcha() {
            return this.captchaEnabled && this.blocked
        }
    },
    methods: {
        onPasswordLogin() {
            this.login(this.form);
        },
        async login(body, url = this.$auth.options.loginData.url || "login") {
            const data = {...body};
            if(this.formCaptcha) {
                data.recaptchaToken = this.formCaptcha
            }
            this.authLoading = true

            try {
                await this.$auth.login({
                    data: data,
                    url,
                    success: this.onSuccess,
                    exception: this.onException,
                    error: this.onError,
                    rememberMe: true,
                })
            } catch (error) {}

            this.authLoading = false
            if(this.$auth.check()) {
                const role = this.$auth?.watch?.data?.role
                if (['user', 'admin', 'operator'].includes(role)) {
                    this.$store.dispatch('Messages/fetchNotReadMessagesCount')
                }
                if (['admin', 'operator'].includes(role)) {
                    // this.$store.dispatch('Users/fetchUsers')
                }
                this.$store.dispatch("Profile/fetchProfile");
            }
        },
        stopLoadings() {
            this.ecpLoginLoading = false;
        },
        onException(resp) {
            this.stopLoadings();

            this.$notify(resp.data.status, {
                title: "Ошибка авторизации",
                variant: "danger",
            });
        },
        onError(error) {
            if(this.ecpLoginLoading) {
                this.onEcpLogin()
            }

            this.stopLoadings();
            const { data } = error.response

            if(this.captchaEnabled) {
                this.$refs['form'].resetCaptcha()
            }
            if (data && data.blocked) {
                this.blocked = true
            }

            if(error.response.data.error === 'Too many users') {
                this.usersList = [{text: "Выберите логин"}, ...error.response.data.users.map(user => ({
                    value: user.id,
                    text: user.name
                }))];
            }

            this.$notify(error.response.data.status || error.response.status + " " + error.response.statusText, {
                title: "Ошибка авторизации",
                variant: "danger",
            });
        },
        onSuccess({ data: { data: user } }) {
            this.$auth.user(user);
            const redirectTo = "main";
            this.$router.push({ name: redirectTo }).catch(err => err);
            this.ecpLoginModal = false;
            this.stopLoadings();
            this.$refs.modal && this.$refs.modal.hide();
        },
        loginBySign(sign, id) {
            this.ecpLoginLoading = true;
            this.login(
                {
                    sign,
                    id
                },
                "/auth/eslogin"
            );
        },
        async onEcpLogin() {
            this.tokenLoading = true;
            const { data: { token } } = await axios.post("/auth/eslogin/attempt")
            this.loginHash = btoa(token);
            this.ecpLoginModal = true;
            this.tokenLoading = false;
        },
        resetForm() {
            this.form = Object.assign({}, initialForm)
        }
    },
};
